export default __webpack_public_path__ + "static/media/illustration-algostudy-n-m@3x.390c409a.png";